var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 61.6667H23.3332V65H6.6665V61.6667ZM71.1872 32.2288L70.0086 33.4074L69.9998 33.3987L42.5186 60.88L26.0425 64.999L30.1616 48.523L58.8127 19.8544C62.2242 16.4429 67.7755 16.4429 71.187 19.8544C74.5986 23.2662 74.5986 28.8172 71.1872 32.2288ZM41.6666 57.018L64.3122 34.3723L56.6867 26.7118L34.0236 49.3749L41.6666 57.018ZM30.6238 60.4177L38.4064 58.4721L32.5694 52.6351L30.6238 60.4177ZM68.83 22.2113C66.8057 20.1868 63.5639 20.103 61.4384 21.9601L59.0437 24.3548L66.6692 32.0154L69.0815 29.6031C70.9384 27.4779 70.8545 24.2361 68.83 22.2113Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.778bb11295f260aee62e277cc25d8cc0.svg";
export { ForwardRef as ReactComponent };